import { useOutletContext } from 'react-router-dom'

/**
 * What `AppShell` hands down to the routed page. It travels through the
 * router's outlet context so a page can render its own header — the Discover,
 * News and Event frames each fill the header's second row differently — without
 * a second provider.
 */
export interface AppChrome {
  openMenu: () => void
  openUserPanel: () => void
  /** Opens the Explore command panel — the same thing ⌘K does. */
  openExplore: () => void
  unreadCount: number
}

export function useAppChrome(): AppChrome {
  return useOutletContext<AppChrome>()
}
